import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Select, { components } from "react-select";
import JoditEditor from "jodit-react";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { toast } from "react-toastify";
import Response_Processing from "../../../layout/Others/Response_Processing";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import useCompressImageConfig from "../../../components/CommonApis/Compressimageapi";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { IoMdInformationCircle } from "react-icons/io";
import { useMyContext } from "../../../components/Provider/CommonProvider";

const MultiValue = (props) => {
  const val = String(props.data.value);
  return (
    <div
      draggable
      onDragStart={(e) => {
        e.dataTransfer.setData("text/plain", val);
        e.dataTransfer.effectAllowed = "move";
      }}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        const dragged = e.dataTransfer.getData("text/plain");
        if (dragged && dragged !== val) props.selectProps.onReorder(dragged, val);
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      style={{ cursor: "grab" }}
    >
      <components.MultiValue {...props} />
    </div>
  );
};

function Video_Playlist() {
  const headers = getItemToken('access_token')
  const { id } = useParams()
  const combinedRef = useRef([]);
  const navigate = useNavigate();
  const { compressResolutionFormat } = useCompressImageConfig();

  const [formData, setFormData] = useState({
    title: '',
    slug: '',
    description: '',
    status: 1,
    selected_videos: [],
  })

  const [formDataError, setFormDataError] = useState({})
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [bannerImageFile, setBannerImageFile] = useState(null);
  const [videoOptions, setVideoOptions] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false);

  const handleReorder = (draggedId, targetId) => {
    const list = [...formData.selected_videos].map(Number);
    const fromIdx = list.indexOf(Number(draggedId));
    const toIdx = list.indexOf(Number(targetId));
    if (fromIdx > -1 && toIdx > -1) {
      list.splice(toIdx, 0, list.splice(fromIdx, 1)[0]);
      setFormData(prev => ({ ...prev, selected_videos: list }));
    }
  };

  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const imageApi = globalImageUplaodAPI();

  const setRef = (element, index) => {
    if (element) {
      combinedRef.current[index] = element;
    }
  };

  const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const ratio = width / height;
        const expectedRatioPrecision = 0.01;
        const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
        const dimensionMatch = (width === expectedWidth && height === expectedHeight);
        if (ratioMatch || dimensionMatch) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      img.onerror = () => {
        toast.error('Error loading image');
      };
    });
  };

  const handleFileChange = async (event) => {
    const { files, name } = event.target
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const checkSize = compressResolutionFormat?.videos === 1
    setFormDataError((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (files?.length > 0) {
      const newFile = files[0];
      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      await readFile(newFile);

      if (!allowedTypes.includes(files[0]?.type)) {
        setFormDataError((prev) => ({
          ...prev,
          [name]: "Only JPG, JPEG, and PNG files are allowed.",
        }));
        if (name === 'image') setCoverImageFile(null);
        if (name === 'banner_image') setBannerImageFile(null);
        combinedRef.current[name]?.focus()
        return;
      }
      if (name === 'image') {
        setCoverImageFile(newFile);
        if (checkSize) {
          const isValidSize = await validateImageRatio(newFile, 2 / 3, 1080, 1620);
          if (!isValidSize) {
            setFormDataError((prev) => ({
              ...prev,
              [name]: "Image must be in 2:3 Ratio or 1080x1620px.",
            }));
          }
        }
      }
      if (name === 'banner_image') {
        setBannerImageFile(newFile);
      }
    }
  };

  const handleAdd = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {
        title: formData?.title,
        slug: formData?.slug,
        description: formData?.description,
        status: Number(formData?.status) === 0 ? 0 : 1,
        selected_videos: formData?.selected_videos || [],
      };
      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/video/playlist-store`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        if (coverImageFile || bannerImageFile) {
          await handleImageUpload(result?.id)
        }
        setShowOverlay(false);
        toast.success(result?.message)
        navigate("/allplaylist");
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const handleImageUpload = async (playlistId) => {
    try {
      if (!coverImageFile && !bannerImageFile) return;
      const formDataAdd = new FormData();
      const modelName = "AdminVideoPlaylist";
      formDataAdd.append('id', playlistId);
      formDataAdd.append('modelName', modelName);
      if (coverImageFile) {
        formDataAdd.append('image', coverImageFile);
        formDataAdd.append('imageFields[]', 'image');
      }
      if (bannerImageFile) {
        formDataAdd.append('banner_image', bannerImageFile);
        formDataAdd.append('imageFields[]', 'banner_image');
      }
      const response = await fetchRequest({
        method: 'POST',
        url: imageApi,
        data: formDataAdd,
      });
      if (response?.status === false) {
        toast.error(response?.message)
      }
      setCoverImageFile(null)
      setBannerImageFile(null)
    } catch (err) {
      console.error(err)
    }
  }

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormDataError((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleStatusChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      status: e.target.checked ? 1 : 0,
    }));
  };

  const handleDescriptionChange = (newContent) => {
    setFormData((prev) => ({
      ...prev,
      description: newContent,
    }));
  };

  const handleSelectedVideos = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      selected_videos: (selectedOptions || []).map((option) => option.value),
    }));
    setFormDataError((prev) => ({
      ...prev,
      selected_videos: '',
    }));
  };

  const handleInputKeyDowntitle = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      if (formData?.slug) {
        return
      }
      generateSlug(formData?.title);
    }
  };
  const handleBlurtitle = () => {
    if (formData?.slug) {
      return
    }
    generateSlug(formData?.title);
  };

  const generateSlug = async (title) => {
    const slug = await slugGenerator(title)
    setFormData((prev) => ({
      ...prev,
      'slug': slug,
    }));
  };

  const fetchVideoOptions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/video-list`, { headers: headers });
      const list = response?.data?.data || [];
      const options = list.map((video) => ({ value: video?.id, label: video?.title }));
      setVideoOptions(options);
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };

  const fetchEditData = () => {
    axios.get(`${process.env.REACT_APP_Baseurl}/admin/video/playlist-edit/${id}`, {
      headers: headers,
    })
      .then((response) => {
        var result = response?.data?.data;
        setFormData({
          ...result,
          status: result?.status === undefined || result?.status === null ? 1 : Number(result?.status),
          selected_videos: Array.isArray(result?.selected_videos) ? result.selected_videos : [],
        })
      })
      .catch((error) => console.log(error));
  }

  const handleBlurTitleEdit = () => {
    generateSlug(formData?.slug);
  };

  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.title) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        title: "Title cannot be empty.",
      }));
      combinedRef.current['title']?.focus()
      formIsValid = false;
    }
    if (!formData?.slug) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        slug: "Slug cannot be empty.",
      }));
      combinedRef.current['slug']?.focus()
      formIsValid = false;
    }
    if (!bannerImageFile && !formData?.banner_image) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        banner_image: "Banner image is required.",
      }));
      combinedRef.current['banner_image']?.focus()
      formIsValid = false;
    }
    if (!formData?.selected_videos || formData?.selected_videos?.length === 0) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        selected_videos: "Please select at least one video.",
      }));
      formIsValid = false;
    }
    if (formDataError?.image) {
      combinedRef.current['image']?.focus()
      formIsValid = false;
    }
    if (formDataError?.banner_image && (bannerImageFile || formData?.banner_image)) {
      combinedRef.current['banner_image']?.focus()
      formIsValid = false;
    }
    return formIsValid;
  }

  const handleStore = () => {
    if (formValidation()) {
      if (!id) {
        handleAdd()
      }
      else {
        handleUpdate()
      }
    }
    else {
      console.log("validation")
    }
  }

  const handleUpdate = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {
        title: formData?.title,
        slug: formData?.slug,
        description: formData?.description,
        status: Number(formData?.status) === 0 ? 0 : 1,
        selected_videos: formData?.selected_videos || [],
      };
      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/video/playlist-update/${id}`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        if (coverImageFile || bannerImageFile) {
          await handleImageUpload(id)
        }
        setShowOverlay(false);
        toast.success(result?.message)
        setWithOutRefresh(!withOutRefresh)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const handleClearSelectFile = () => {
    setCoverImageFile(null)
  }

  const handleClearBannerFile = () => {
    setBannerImageFile(null)
  }

  useEffect(() => {
    fetchVideoOptions()
  }, []);

  useEffect(async () => {
    if (id) {
      await fetchEditData()
    }
  }, [withOutRefresh]);

  const selectedVideoValues = (formData?.selected_videos || [])
    .map((id) => (videoOptions || []).find((option) => Number(option.value) === Number(id)))
    .filter(Boolean);

  return (
    <div className="pb-5">

      {showOverlay && (<Response_Processing></Response_Processing>)}
      {<AdminBackNavigation path={`${"/allplaylist"}`} text="Back" />}
      <AdminSaveHeader buttonId="video-playlist-submit-up" heading={!id ? "Add Video Playlist" : "Edit Video Playlist"} saveText={!id ? "Add Playlist" : "Update Playlist"} saveMethod={handleStore} />
      <FormContainer>
        <LeftWrapper>
          {/* Section 1 : Playlist Name, Slug, Description */}
          <Wrapper>
            <MessageLabel text={"Playlist Name"} className="mandatorySimple" />
            <AdminCustomInput id="video-playlist-title" type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />
            <MessageLabel text={"Slug"} className="mandatorySimple" />
            <AdminCustomInput id="video-playlist-slug" type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} placeHolder={"Slug"} onBlur={handleBlurTitleEdit} error={formDataError?.slug} />
            <MessageLabel text={"Description"} />
            <JoditEditor
              className="video-details mb-3"
              value={formData?.description || ""}
              onChange={handleDescriptionChange}
              ref={(el) => (combinedRef.current.description = el)}
            />
          </Wrapper>
          {/* Section 3 : Video Playlist */}
          <Wrapper>
            <MessageHeading text={"Video Playlist"} />
            <MessageLabel text={"Videos"} className="mandatorySimple" />
            <MessageSubHeading text={"Search and select the videos for this playlist"} />
            <Select
              id="video-playlist-selected-videos"
              isMulti
              name="selected_videos"
              options={videoOptions}
              value={selectedVideoValues}
              onChange={handleSelectedVideos}
              ref={(el) => (combinedRef.current.selected_videos = el)}
              classNamePrefix="select"
              placeholder="Select videos"
              className="custom-select-multi custom-placeholder theme-text-color mb-2"
              components={{ MultiValue }}
              onReorder={handleReorder}
            />
            {formDataError?.selected_videos && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.selected_videos}`} classname='errorred d-block' /></div>)}
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"Thumbnail Image"} />
            <MessageLabel text={"Image"} />
            <MessageSubHeading text={"Select the image( 2:3 Ratio or 1080x1620px )"} />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={coverImageFile}
              uploadedImage={formData?.image}
              onDelete={handleClearSelectFile}
              fileInputRef={setRef}
              name="image"
              id={id}
              idAttribute="video-playlist-image"
              ref={(el) => (combinedRef.current.image = el)}
              error={formDataError?.image}
            />
            <MessageLabel text={"Banner"} className="mandatorySimple" />
            <MessageSubHeading text={"Select the banner image( 16:9 Ratio recommended )"} />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={bannerImageFile}
              uploadedImage={formData?.banner_image}
              onDelete={handleClearBannerFile}
              fileInputRef={setRef}
              name="banner_image"
              id={id}
              idAttribute="video-playlist-banner-image"
              ref={(el) => (combinedRef.current.banner_image = el)}
              error={formDataError?.banner_image}
            />
          </Wrapper>

           <Wrapper>
            <MessageLabel text={"Status"} />
            <AdminSwitch id="video-playlist-status" name="status" checked={Number(formData?.status) === 1} onChange={handleStatusChange} />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton id="video-playlist-submit-down" className='px-3 py-1 m-0 ms-auto' saveMethod={handleStore} saveText={!id ? "Add Playlist" : "Update Playlist"} />
      </FormContainer>
    </div>
  );
}

export default Video_Playlist;
